























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { vehicleInventoryService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class RfidTagsListPage extends Base {
  public rfidTagsList: any[] = [];
  public headers: VHeaders[] = [];
  public rfidLocations: any[] = [];
  public locationsHeader: VHeaders[] = [];
  public loading: boolean = false;
  public locationsLoading: boolean = false;

  // Dialog
  public rfidLocationsDialog: IDialogOption = {
    width: 800,
    title: 'RFID Locations ',
    model: false,
    loading: false,
  };

  public isPageDestroyed: boolean = false;
  public selected: any[] = [];
  public actions: any[] = [];
  public pagination = new PaginationModel('createdAt', true);
  public locationsPagination = new PaginationModel('posteddate', true);

  constructor() {
    super();
  }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-info',
        title: 'Locations',
        action: (model: any) => {
          this.locations(model);
        },
      },
    ];
  }

  public locations(model) {
    this.rfidLocationsDialog.model = true;
    this.locationsLoading = true;
    this.rfidLocations = [];
    if (model.location.length > 0) {
      this.rfidLocations = model.location;
    }
    this.locationsLoading = false;
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'rfid');

    this.setActions();
    this.setHeaders();
    this.getRfidTagList();
  }

  public setHeaders() {
    this.headers = [

      {
        text: 'Rfid Tag',
        align: 'left',
        value: 'rfidTag',
        sortable: true,
      },
      {
        text: 'Created At',
        align: 'left',
        value: 'createdAt',
        fieldType: 'date',
        sortable: false,
      },
      {
        text: 'Last Scan At',
        align: 'left',
        value: 'updatedAt',
        fieldType: 'date',
        sortable: false,
      },
      {
        align: 'left',
        text: 'Action',
        isNotDataProp: true,
        sortable: false,
      },
    ];

    this.locationsHeader = [
      {
        text: 'Reader Name',
        align: 'left',
        value: 'serverName',
        sortable: false,
      },
      {
        text: 'Location Name',
        align: 'left',
        value: 'locationName',
        sortable: false,
      },
      {
        text: 'DMS Location Id',
        align: 'left',
        value: 'location',
        sortable: false,
      },
      {
        text: 'Created At',
        align: 'left',
        value: 'createdAt',
        sortable: true,
        fieldType: 'date',
      },
      {
        text: 'Last Scan At',
        align: 'left',
        value: 'updatedAt',
        sortable: true,
        fieldType: 'date',
      },
    ];
  }

  public beforeDestroy(): void {
    this.isPageDestroyed = true;
  }

  public async getRfidTagList(): Promise<void> {

    if (this.isPageDestroyed) return;
    try {
      this.loading = true;
      const queryStringObj = Object.assign({}, this.pagination);
      Utils.validateAndUpdateRoute(queryStringObj);

      const result = await vehicleInventoryService.getRfidTagList(this.pagination);
      this.rfidTagsList = result.results;
      this.pagination.totalItems = result.total;

      const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
      if (pagination) {
        this.pagination = pagination;
      }
      this.updatePaging(this.pagination);
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
    const queryStringObj = Object.assign({}, this.pagination);
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getRfidTagList();
  }

  public updateLocationsPaging(paging: any): void {
    this.locationsPagination = paging;
  }
}
